import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditInsultedPageNew from "../../components/Insulated/AddInsulatedPageNew";



const EditInsulatedPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Insulated" link2="/insulated" title="Edit Insulated" />

        {/* AddUserLayer */}
        <EditInsultedPageNew />


      </MasterLayout>
    </>
  );
};

export default EditInsulatedPage;
